// extracted by extract-css-chunks-webpack-plugin
module.exports = {"post_list":"ArticleListTags__post_list---tiJg","empty_list_placeholder":"ArticleListTags__empty_list_placeholder--aBl0n"};